import config from 'root/common/config/config';
import { addDomain } from '../../../api/utils';

let urls = {
    pageImage: '/timedReminder/v1/pageImage',
    list: '/timedReminder/v1/list',
    deleteReminder: '/timedReminder/v1/delete',
    editReminder: '/timedReminder/v1/detail',
    storeReminder: '/timedReminder/v1/create',
    saveReminder: '/timedReminder/v1/update',
    reminderInfo: '/timedReminder/v1/msgInfo',
};

export default addDomain(urls, config.privilegeApiDomain);
